import '@adornis/buchungsheld-components/authentication/bh-login.js';
import { User } from '@adornis/buchungsheld-db/entities/user.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { useQuery } from '@adornis/functional-lit/use-query.js';
import '@adornis/user-forms/x-login.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import { html, nothing } from 'lit';
import { filter, switchMap } from 'rxjs';
import * as m from '../../../../localization/out/messages.js';

export const RegisterLoginOrRegister = stateful(() => {
  // TODO (low prio) make this nice code in engine...
  const user = useQuery(
    () =>
      currentUser<User>().isLoading.pipe(
        filter(loading => !loading),
        switchMap(() => currentUser<User>()),
      ),
    [],
  );

  if (user.loading)
    return html`<div class="flex min-h-dvh flex-col">
      <div class="p-8 text-center"><span class="loading loading-lg"></span></div>
    </div>`;

  return !user.value
    ? html`
        <div class="grid gap-6 md:grid-cols-1">
          <div class="card bg-base-100">
            <div class="card-body gap-4">
              <bh-login></bh-login>

              <a href="/privacy" class="link self-end mt-4" target="_blank">${m.privacy_policy()}</a>
            </div>
          </div>
        </div>
      `
    : nothing;
});
